import {
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import PropTypes from "prop-types";

import React, { useEffect, useMemo, useState } from 'react';
import {
  StyledAdvEditorToolbarFormatGroup,
  StyledAdvEditorToolbarRow,
  StyledSliderInputContainer,
} from "../styled/details/stylesDetails";
import EditableLabel from "./EditableLabel";

function Title(props) {
  return <div className="title">{props.title}</div>;
}

function InputBox(props) {
  const { text, handleFocus, handleFocusOut, maxLength } = props;
  return (
    <StyledSliderInputContainer showValue={true}>
      <EditableLabel
        type="number"
        text={`${text}`}
        labelClassName="slidervaluename"
        inputClassName="slidervalueinput"
        onFocus={handleFocus}
        onFocusOut={handleFocusOut}
        showIcon={false}
        inputMaxLength={maxLength}
        labelPlaceHolder={`${text}`}
      />
    </StyledSliderInputContainer>
  );
}

function SliderWithInput(props) {
  const {
    step,
    values,
    onChange,
    onUpdate,
    isWithMarginLeft,
    title,
    disabled,
    domain,
    variant,
    hideIndicator,
    unit,
    maxLength,
    handleFocus,
    handleFocusOut,
  } = props;

  const minValue  = useMemo(() => domain ? domain[0] : 0, [domain]);
  const maxValue  = useMemo(() => domain ? domain[1] : 100, [domain]);

  const [rangeValue, setRangeValue] = useState(values ? values : minValue);

  const [inputValue, setInputValue] = useState(
    values
      ? step % 1 === 0 || !step
        ? parseFloat(values)
        : parseFloat(values).toFixed(1)
      : minValue
  );

  useEffect(() => {
    setRangeValue(values);
    setInputValue(
      step % 1 === 0 || !step
        ? parseFloat(values)
        : parseFloat(values).toFixed(1)
    );
  }, [values]);

  const handleRangeSLider = (e) => {
    setRangeValue(e);
    if (onChange) onChange(e);
    if (step % 1 === 0 || !step) {
      setInputValue(parseFloat(e));
    } else {
      setInputValue(parseFloat(e).toFixed(1));
    }
  };

  const handleRangeSliderUpdate = (e) => {
    setRangeValue(e);
    if (onUpdate) onUpdate(e);
  };

  const handleFocusFunc = (e) => {
    if (handleFocus && e.match(/^[1-9]\d*(\.\d+)?$/)) {
      if (step % 1 === 0 || !step) {
        handleFocus(parseFloat(Number(e)));
      } else {
        handleFocus(Number(parseFloat(Number(e)).toFixed(1)));
      }
    } else if (handleFocus) {
      handleFocus(minValue);
    }
  };
  const handleFocusOutFunc = (e) => {
    if (handleFocusOut && e.match(/^[1-9]\d*(\.\d+)?$/)) {
      if (step % 1 === 0 || !step) {
        handleFocusOut(parseFloat(Number(e)));
      } else {
        handleFocusOut(Number(parseFloat(Number(e)).toFixed(1)));
      }
      setRangeValue(e);
    } else if (handleFocusOut) {
      handleFocusOut(minValue);
      setInputValue(minValue);
      setRangeValue(minValue);
    }
  };

  return (
    <>
      <StyledAdvEditorToolbarRow isWithValue={true}>
        <StyledAdvEditorToolbarFormatGroup
          isWithValue={true}
          isWithMarginLeft={isWithMarginLeft}
        >
          <Title title={title ? title : ""} />
          <Slider
            colorScheme="primary"
            aria-label="slider-bar"
            defaultValue={30}
            className="tldr-slider"
            step={step || 1}
            value={rangeValue}
            onChangeEnd={(e) => handleRangeSliderUpdate(e)}
            onChange={(e) => handleRangeSLider(e)}
            disabled={disabled}
            min={minValue}
            max={maxValue}
            variant={variant}
            w="96%"
          >
            {!hideIndicator && (
              <SliderMark
                value={rangeValue}
                textAlign="center"
                bg="transparent"
                color="primary.200"
                mt="-5"
                ml="-5"
                w="12"
              >
                {rangeValue}
                {unit && unit}
              </SliderMark>
            )}
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb />
          </Slider>
        </StyledAdvEditorToolbarFormatGroup>

        <InputBox
          text={inputValue}
          maxLength={maxLength ? maxLength : 1}
          handleFocus={handleFocusFunc}
          handleFocusOut={handleFocusOutFunc}
        />
      </StyledAdvEditorToolbarRow>
    </>
  );
}

SliderWithInput.propTypes = {
  handleFocus: PropTypes.func,
  handleFocusOut: PropTypes.func,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
};

function SliderWithoutInput(props) {
  const {
    values,
    onChange,
    onUpdate,
    title,
    classNames,
    step,
    domain,
    disabled,
    variant,
    hideIndicator,
    unit,
  } = props;

  const minValue  = useMemo(() => domain ? domain[0] : 0, [domain]);
  const maxValue  = useMemo(() => domain ? domain[1] : 100, [domain]);

  const [rangeValue, setRangeValue] = useState(values ? values : minValue);

  useEffect(() => {
    if (values) setRangeValue(values);
  }, [values]);

  const handleRangeSLider = (e) => {
    setRangeValue(e);
    if (onChange) onChange(e);
  };

  const handleRangeSliderUpdate = (e) => {
    setRangeValue(e);
    if (onUpdate) onUpdate(e);
  };
  return (
    <>
      <Title title={title ? title : ""} />
      <Slider
        aria-label="slider-bar"
        defaultValue={30}
        className={`tldr-slider ${classNames}`}
        step={step || 1}
        colorScheme="primary"
        value={rangeValue}
        onChangeEnd={(e) => handleRangeSliderUpdate(e)}
        onChange={(e) => handleRangeSLider(e)}
        disabled={disabled}
        min={minValue}
        max={maxValue}
        variant={variant}
        w="96%"
      >
        {!hideIndicator && (
          <SliderMark
            value={rangeValue}
            textAlign="center"
            bg="transparent"
            color="primary.200"
            mt="-5"
            ml="-5"
            w="12"
          >
            {rangeValue}
            {unit && unit}
          </SliderMark>
        )}
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb />
      </Slider>
    </>
  );
}

SliderWithoutInput.propTypes = {
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
};

function RangeSliderWithoutInput(props) {
  const {
    values,
    onChange,
    onUpdate,
    title,
    classNames,
    step,
    domain,
    variant,
  } = props;

  const [rangeValue, setRangeValue] = useState(values ? values : [0, 100]);
  const handleRangeSLider = (e) => {
    if (onChange) onChange(e);
    setRangeValue(e);
  };

  const handleRangeSliderUpdate = (e) => {
    if (onUpdate) onUpdate(e);
    setRangeValue(e);
  };

  return (
    <>
      <Title title={title ? title : ""} />
      <RangeSlider
        aria-label={["Range-min", "Range-max"]}
        defaultValue={[0, 30]}
        className={`tldr-slider ${classNames}`}
        step={step || 1}
        min={domain ? domain[0] : 0}
        max={domain ? domain[1] : 100}
        value={rangeValue}
        onChangeEnd={(e) => handleRangeSliderUpdate(e)}
        onChange={(e) => handleRangeSLider(e)}
        w="96%"
        variant={variant}
      >
        <RangeSliderTrack>
          <RangeSliderFilledTrack />
        </RangeSliderTrack>
        <RangeSliderThumb index={0} />
        <RangeSliderThumb index={1} />
      </RangeSlider>
    </>
  );
}

RangeSliderWithoutInput.propTypes = {
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
};
function TldrChakraSlider(props) {
  if (props.showInputbox) {
    return SliderWithInput(props);
  } else if (props.mode === 2) {
    return RangeSliderWithoutInput(props);
  } else {
    return SliderWithoutInput(props);
  }
}

TldrChakraSlider.propTypes = {};

export default TldrChakraSlider;
